export default __webpack_public_path__ + "static/media/6.5ad05cc1.png";